export default {
  "profileFeedback.meAccountRoute.1": "Unauthorized",
  "profileFeedback.meAccountRoute.2": "Invalid email payload",
  "profileFeedback.meAccountRoute.3": "Too many attempts. Try again shortly.",
  "profileFeedback.meAccountRoute.4": "Invalid password payload",
  "profileFeedback.meAccountRoute.5": "Too many attempts. Try again shortly.",
  "profileFeedback.meAccountRoute.6": "New passwords do not match.",
  "profileFeedback.meAccountRoute.7": "New password must be different from the current password.",
  "profileFeedback.account.passwordMinimum": "Password must be at least {{count}} characters.",
  "profileFeedback.meAccountRoute.8": "User not found.",
  "profileFeedback.meAccountRoute.9": "Current password is incorrect.",
  "profileFeedback.meBannerRoute.1": "Unauthorized",
  "profileFeedback.meBannerRoute.2": "Expected multipart/form-data",
  "profileFeedback.meBannerRoute.3": "No file provided",
  "profileFeedback.meSessionsRoute.1": "Unauthorized",
  "profileFeedback.meSessionsRoute.2": "Unable to load sessions",
  "profileFeedback.meNotificationsRoute.1": "Unauthorized",
  "profileFeedback.meNotificationsRoute.2": "Unable to load notification settings",
  "profileFeedback.meNotificationsRoute.3": "External notifications are disabled by your administrator.",
  "profileFeedback.meNotificationsRoute.4": "Email notifications are not configured by your administrator.",
  "profileFeedback.meNotificationsRoute.5": "Unable to save notification settings",
  "profileFeedback.meNotificationsRoute.6": "Discord notifications are disabled by your administrator.",
  "profileFeedback.meNotificationsRoute.7": "No valid Discord webhook URL configured. Save a webhook URL first.",
  "profileFeedback.meNotificationsRoute.8": "Unable to send test message",
  "profileFeedback.meNotificationsRoute.9": "Discord notifications are disabled by your administrator.",
  "profileFeedback.meNotificationsRoute.10": "Discord bot DM delivery is not enabled by your administrator.",
  "profileFeedback.meNotificationsRoute.11": "Discord bot is not configured. Ask your administrator to set up the bot token.",
  "profileFeedback.meNotificationsRoute.12": "No valid Discord User ID configured. Save your Discord User ID first.",
  "profileFeedback.meNotificationsRoute.13": "Unable to send test DM",
  "profileFeedback.supportRoute.1": "Unauthorized",
  "profileFeedback.supportRoute.2": "Admin privileges required.",
  "profileFeedback.supportRoute.3": "Insufficient permissions",
  "profileFeedback.supportRoute.4": "Invalid CSRF token",
  "profileFeedback.supportRoute.5": "Invalid action. Must be 'enable', 'disable', or 'status'.",
  "profileFeedback.supportRoute.6": "A support operation is already in progress.",
  "profileFeedback.supportRoute.7": "Insufficient permissions",
  "profileFeedback.supportRoute.8": "Insufficient permissions",
  "profileFeedback.twoFaRoute.1": "Verification required.",
  "profileFeedback.twoFaRoute.2": "Auth security tables are not initialized. Run npm run db:init or enable QB_DB_AUTO_MIGRATE.",
  "profileFeedback.twoFaRoute.3": "Unauthorized",
  "profileFeedback.twoFaRoute.4": "Two-factor authentication already enabled.",
  "profileFeedback.twoFaRoute.5": "Invalid verification payload.",
  "profileFeedback.twoFaRoute.6": "Too many attempts. Try again shortly.",
  "profileFeedback.twoFaRoute.7": "Invalid request.",
  "profileFeedback.twoFaRoute.8": "Invalid request.",
  "profileFeedback.passkeyRoute.1": "Unauthorized",
  "profileFeedback.passkeyRoute.2": "Auth security tables are not initialized. Run npm run db:init or enable QB_DB_AUTO_MIGRATE.",
  "profileFeedback.passkeyRoute.3": "Invalid request.",
  "profileFeedback.passkeyRoute.4": "Too many attempts. Try again shortly.",
  "profileFeedback.passkeyRoute.5": "Invalid request.",
  "profileFeedback.passkeyRoute.6": "Too many attempts. Try again shortly.",
  "profileFeedback.passkeyRoute.7": "Invalid name.",
  "profileFeedback.passkeyRoute.8": "Invalid credential id.",
  "profileFeedback.passkeyRoute.9": "Invalid credential id.",
  "profileFeedback.twoFactorService.1": "2FA enrollment not started.",
  "profileFeedback.twoFactorService.2": "Invalid verification code.",
  "profileFeedback.bannerUtils.1": "File too large",
  "profileFeedback.bannerUtils.2": "Unsupported file type",
  "profileFeedback.bannerUtils.3": "Unsupported file type",
  "profileFeedback.bannerUtils.4": "Unsupported file type",
  "profileFeedback.bannerUtils.5": "Unsupported file type",
  "profileFeedback.bannerUtils.6": "Unsupported file type",
  "profileFeedback.banner.readLarge": "File too large",
  "profileFeedback.banner.readFailed": "Failed to read upload",
  "profileFeedback.passkey.challengeExpired": "Registration challenge expired. Please retry.",
  "profileFeedback.passkey.verificationFailed": "Passkey verification failed",
  "profileFeedback.device.unknown": "Unknown device",
  "profileFeedback.device.known": "{{browser}} on {{os}}",
  "profileFeedback.device.unknownOs": "{{browser}} on an unknown OS",
  "profileFeedback.device.genericBrowser": "Browser on {{os}}",
  "profileFeedback.notifications.webhookSent": "Test message sent to your Discord channel.",
  "profileFeedback.notifications.dmSent": "Test DM sent. Check your Discord messages.",
  "profileFeedback.account.passwordMinimumOne": "Password must be at least {{count}} character."
} as const;
